import { collection, getDocs, query, where } from "firebase/firestore";
import { useRef } from "react";
import { useEffect, useState } from "react";
import { useReactToPrint } from "react-to-print";
import GetSingleAttendance from "../../../../Controllers/Admin/Attendance/GetSingleAttendance";
import GetStudentInTheAttendance from "../../../../Controllers/Admin/Attendance/GetStudentInTheAttendance";

export default function PreviousAttendanceViewModel() {
  const urlParams = new URLSearchParams(window.location.search);

  let docId = urlParams.get("docId");
  const [Attendance, setAttendance] = useState();
  const [FinalResult, setFinalResult] = useState();
  const [AttendanceDate, setAttendanceDate] = useState();

  useEffect(() => {
    const fetchData = async () => {
      if (docId) {
        let resp = await GetSingleAttendance(docId);
        setAttendance(resp);
        setAttendanceDate(resp?.AttendanceDate);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (Attendance) {
        let resp = await GetStudentInTheAttendance(Attendance.Students);
        MakeFinalResult(resp);
      }
    };
    fetchData();
  }, [Attendance]);

  const MakeFinalResult = (resp) => {
    let temp = [];
    resp.map((item) => {
      let e = Attendance?.Students.find((std) => {
        return std.id == item.id;
      });

      if (e) {
        temp.push({
          IsPresent: e.IsPresent,
          ...item,
        });
      }
    });

    setFinalResult([...temp]);
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return { FinalResult, AttendanceDate, componentRef, handlePrint };
}
